export const Colors = {
  primary: '#8338EC',
  secondary: '#FFBE0B'
}